import { CSSProperties, FC, ReactNode } from 'react'

import { BorderRadius8, GreyWhite, Flex } from '@sequencehq/core-components'

type CardProps = Pick<
  CSSProperties,
  'padding' | 'gap' | 'width' | 'border' | 'borderRadius' | 'transition'
> & {
  children: ReactNode
  'data-testid'?: string
}

export const Card: FC<CardProps> = ({ children, ...props }) => {
  return (
    <Flex
      padding="8px"
      flexDir="column"
      backgroundColor={GreyWhite}
      border="rgba(0, 0, 0, 0.08) 1px solid"
      borderRadius={BorderRadius8}
      overflow="hidden"
      width={props.width ?? '100%'}
      {...props}
    >
      {children}
    </Flex>
  )
}
